// Analytics Configuration
export const ANALYTICS_CONFIG = {
  // Google Analytics 4
  GA4_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || 'G-NF49NHPB76',
  
  // Google Tag Manager
  GTM_CONTAINER_ID: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID || 'GTM-N4HDJW6',
  
  // Amplitude
  AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_KEY,
  
  // Environment
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  
  // Feature flags - default to false for optional services
  ENABLE_AMPLITUDE: false, // Disabled to avoid build errors
  ENABLE_GTM: process.env.NEXT_PUBLIC_ENABLE_GTM !== 'false', // Default to true
  ENABLE_GA4: process.env.NEXT_PUBLIC_ENABLE_GA4 === 'true',
};

// Standard event names
export const ANALYTICS_EVENTS = {
  // Page events
  PAGE_VIEW: 'page_view',
  SCREEN_VIEW: 'screen_view',
  
  // User events
  USER_SIGNUP: 'sign_up',
  USER_LOGIN: 'login',
  
  // E-commerce events
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  
  // Lead generation
  GENERATE_LEAD: 'generate_lead',
  FORM_SUBMIT: 'form_submit',
  
  // Vehicle specific
  VEHICLE_VIEWED: 'vehicle_viewed',
  TEST_DRIVE_REQUESTED: 'test_drive_requested',
  QUOTE_REQUESTED: 'quote_requested',
  
  // Engagement
  CLICK: 'click',
  SCROLL: 'scroll',
  SEARCH: 'search',
};
